import React from 'react';
import { Button } from '@mui/material';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import Link from '../Link';
import styles from './styles.module.scss';

type CarritoVacioProps = {
    mensaje: string
    ctaHref: string
    ctaLabel: string
}

const CarritoVacio = ({ mensaje, ctaHref, ctaLabel }: CarritoVacioProps) => {

  return (<>
    <div className={styles.contenedor}>
      <div className={styles.icono}>
        <ShoppingBagOutlinedIcon />
      </div>
      <p className={styles.mensaje}>{mensaje}</p>
      <Link href={ctaHref}>
        <Button
          color="otherPink2"
          variant="outlined"
          style={{
            padding: "16px 36px",
            display: "flex",
            gap: "12px",
          }}
        >{ctaLabel}</Button>
      </Link>
    </div>
  </>);
};

export default CarritoVacio;
